import cx from 'classnames';
import { Alarm, Close } from 'education-icons';
import { Text } from 'platform-components';
import React from 'react';
import { connect } from 'react-redux';
import { Action, bindActionCreators, Dispatch } from 'redux';

import * as actions from 'common.components/lesson-view.store/actions';
import { LessonViewStore } from 'common.components/lesson-view.store/interfaces';

import * as selectors from './selectors';

import './lesson-view__notification.scss';

interface OwnProps {
    mix?: string;
}

interface StoreProps {
    shouldShow: boolean;
    textId: string | null;
}

interface DispatchProps {
    toggleLessonNotification: typeof actions.toggleLessonNotification;
}

interface Props extends OwnProps, StoreProps, DispatchProps {}

const LessonNotification = (props: Props) => {
    const { mix, shouldShow, textId, toggleLessonNotification } = props;

    if (!shouldShow || !textId) {
        return null;
    }

    const handleClose = () => {
        toggleLessonNotification(false);
    };

    return (
        <div className={cx('lesson-view__notification', mix)}>
            <div className="lesson-view__notification-content">
                <Alarm className="lesson-view__notification-alarm" />
                <Text id={textId} type={Text.TYPE.MARKDOWN} />
            </div>
            <Close className="lesson-view__notification-close" onClick={handleClose} />
        </div>
    );
};

const mapStateToProps = <T extends LessonViewStore>(storeState: T): StoreProps => ({
    shouldShow: selectors.getShouldShowNotification(storeState),
    textId: selectors.getNotificationsTextId(storeState),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>): DispatchProps => {
    return bindActionCreators(
        {
            toggleLessonNotification: actions.toggleLessonNotification,
        },
        dispatch
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(LessonNotification);
